import { useQuery } from '@tanstack/react-query';
import { supabase } from '../services/supabase';
import { useSyncClearstream } from './useClearstreamSync';

export interface WelcomeInOptInUser {
  id: string;
  sheet_row_id: string;
  first_name?: string | null;
  last_name?: string | null;
  email?: string | null;
  phone?: string | null;
  roles?: string[] | null;
  opted_in_at?: string | null;
  created_at?: string | null;
}

type SyncMeta = {
  id: number;
  last_synced_at: string | null;
};

export const useWelcomeInOptIns = () =>
  useQuery<WelcomeInOptInUser[]>({
    queryKey: ['welcome-in-opt-ins'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('welcome_in_opt_ins')
        .select(
          'id, sheet_row_id, first_name, last_name, email, phone, roles, opted_in_at, created_at'
        )
        .order('opted_in_at', { ascending: false })
        .order('created_at', { ascending: false })
        .limit(500);
      if (error) throw error;
      return data as WelcomeInOptInUser[];
    },
    staleTime: 60_000,
  });

export const useWelcomeInOptInSyncMeta = () =>
  useQuery<SyncMeta | null>({
    queryKey: ['welcome-in-opt-in-sync-meta'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('welcome_in_opt_in_sync_meta')
        .select('*')
        .order('id', { ascending: true })
        .limit(1)
        .maybeSingle();
      if (error) throw error;
      return (data as SyncMeta) ?? null;
    },
    staleTime: 60_000,
  });

export const useSyncWelcomeInOptIns = () => useSyncClearstream('welcome_in');
